import indexersAPI from '@/api/indexersAPI';
import dashboardAPI from '@/api/dashboardAPI.js';

/**************** STATE *******************/
const state = {
  indexers: [],
  currentUsergroupIndexers: [],
  indexersTypes: [],
  currentIndexer: null,
  trialResults: [],
  trialError: null,
  currentIndexerLogs: []
};

/**************** GETTERS *****************/
const getters = {
  usergroupIndexers: (state) => (usergroupId) => {
    return state.indexers.filter(el => el.usergroup.id === usergroupId);
  }
};

/*************** MUTATIONS ****************/
const mutations = {
  SET_INDEXERS: (state, payload) => {
    state.indexers = payload;
  },
  SET_CURRENT_USERGROUP_INDEXERS: (state, payload) => {
    if (payload && payload.results) {
      state.currentUsergroupIndexers = payload.results;
    } else {
      state.currentUsergroupIndexers = [];
    }
  },
  SET_INDEXERS_TYPES: (state, payload) => {
    state.indexersTypes = payload;
  },
  SET_CURRENT_INDEXER: (state, payload) => {
    if (payload) {
      state.currentIndexer = payload;
    } else {
      state.currentIndexer = null;
    }
  },
  SET_TRIAL_RESULTS: (state, payload) => {
    if (payload) {
      state.trialResults = payload;
    } else {
      state.trialResults = [];
    }
  },
  SET_TRIAL_ERROR: (state, payload) => {
    if (payload) {
      state.trialError = payload;
    } else {
      state.trialError = null;
    }
  },
  SET_CURRENT_INDEXER_LOGS: (state, payload) => {
    if (payload) {
      state.currentIndexerLogs = payload;
    } else {
      state.currentIndexerLogs = [];
    }
  }
};
/**************** ACTIONS *****************/
const actions = {
  GET_INDEXERS: async ({ commit }) => {
    const indexers = await indexersAPI.getIndexers();
    commit('SET_INDEXERS', indexers);
  },
  GET_USERGROUP_INDEXERS: async ({ commit }, usergroupId) => {
    const currentUsergroupIndexers = await indexersAPI.getUsergroupIndexers(usergroupId);
    commit('SET_CURRENT_USERGROUP_INDEXERS', currentUsergroupIndexers);
  },
  GET_INDEXERS_TYPES: async ({ commit }) => {
    const indexersTypes = await indexersAPI.getIndexersTypes();
    commit('SET_INDEXERS_TYPES', indexersTypes);
  },
  CREATE_INDEXER: async ({ dispatch }, data) => {
    const createdIndexer = await indexersAPI.createIndexer(data);
    await dispatch('GET_CURRENT_INDEXER', createdIndexer.id);
  },
  GET_CURRENT_INDEXER: async ({ commit }, id) => {
    const currentIndexer = await indexersAPI.getIndexer(id);
    commit('SET_CURRENT_INDEXER', currentIndexer);
  },
  TEST_CURRENT_INDEXER: async ({ commit }, indexerId) => {
    const trialResults = await indexersAPI.testIndexer(indexerId);
    if (trialResults && trialResults.result) {
      commit('SET_TRIAL_RESULTS', trialResults.result);
    } else if (trialResults && trialResults.status === 'FAILURE') {
      commit('SET_TRIAL_ERROR', trialResults.err);
    }
  },
  UPDATE_CURRENT_INDEXER: async ({ commit }, { id, data }) => {
    const updatedIndexer = await indexersAPI.updateIndexer(id, data);
    commit('SET_CURRENT_INDEXER', updatedIndexer);
  },
  DELETE_INDEXER: async ({ dispatch }, { indexerId, usergroupId }) => {
    await indexersAPI.deleteIndexer(indexerId);
    await dispatch('GET_USERGROUP_INDEXERS', usergroupId);
  },
  GET_CURRENT_INDEXER_LOGS: async ({ commit }, indexerId) => {
    const currentIndexerLogs = await dashboardAPI.getIndexerLogs(indexerId);
    if (currentIndexerLogs && currentIndexerLogs.results) {
      commit('SET_CURRENT_INDEXER_LOGS', currentIndexerLogs.results);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
